import { useContext } from 'react';
import * as SingleSelect from '@givebutter/primitives/single-select';
import { FilterGroupContext } from 'components/filter/filters-next/FilterGroupContext';
import { FilterProviderContext } from 'components/filter/filters-next/FilterProvider';
import { filterGroupOperatorClassName } from 'components/filter/filters-next/props';
import { useFiltersByKey } from 'components/filter/filters-next/useFiltersByKey';
import { ConditionalOperator } from 'components/filter/types';
import { useFiltersCache } from 'contexts/useFiltersCache';

const OuterGroupOperator = () => {
    const { cacheKey } = useContext(FilterProviderContext);
    const { groupId } = useContext(FilterGroupContext);
    const { currentGroup, filterGroups } = useFiltersByKey(cacheKey, groupId);
    const setFilters = useFiltersCache(state => state.updateFiltersNextByKey);

    if (!currentGroup) {
        return null;
    }

    return (
        <SingleSelect.Root
            value={currentGroup.outerOperator}
            onValueChange={value => {
                setFilters(
                    cacheKey,
                    filterGroups.map(f => ({
                        ...f,
                        outerOperator: value as ConditionalOperator,
                    })),
                );
            }}
        >
            <SingleSelect.Trigger
                arial-label="Operator"
                size="sm"
                className={filterGroupOperatorClassName}
            >
                <SingleSelect.Value placeholder="Select an operator" />
            </SingleSelect.Trigger>
            <SingleSelect.Content>
                <SingleSelect.Item value="and">
                    <SingleSelect.ItemText>And</SingleSelect.ItemText>
                </SingleSelect.Item>
                <SingleSelect.Item value="or">
                    <SingleSelect.ItemText>Or</SingleSelect.ItemText>
                </SingleSelect.Item>
            </SingleSelect.Content>
        </SingleSelect.Root>
    );
};

export { OuterGroupOperator };
